import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";

const url = "/api/contactus/sendemail";

export interface SubmitContactUsFormApiParameter extends ApiParameter {
    FirstName?: string;
    LastName?: string;
    CompanyName?: string;
    BusinessType?: string;
    Website?: string;
    ReasonForContact?: string;
    Phone?: string;
    Email?: string;
    Message?: string;
    emailTo?: string;
}

export function submitContactUsForm(parameter: SubmitContactUsFormApiParameter) {
    return post<SubmitContactUsFormApiParameter>(`${url}`, parameter);
}
